export default __webpack_public_path__ + "static/media/trr-drink-cocktail-springdream.263fb428.png";